import { render, staticRenderFns } from "./VueCodemirror.vue?vue&type=template&id=3d28637a"
import script from "./VueCodemirror.vue?vue&type=script&lang=js"
export * from "./VueCodemirror.vue?vue&type=script&lang=js"
import style0 from "./VueCodemirror.vue?vue&type=style&index=0&id=3d28637a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports